import { render, staticRenderFns } from "./PAlertMustReadItem.vue?vue&type=template&id=3a529992"
import script from "./PAlertMustReadItem.vue?vue&type=script&lang=js"
export * from "./PAlertMustReadItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports